// import { getAllLrApi } from "_services";
// import { CityDropdownForTrip, CommonDateRange, CommonInput, CommonModal, CustomPagination, CustomSelect } from "components";
// import React, { useContext, useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import StorageService from "utils/StorageServices/StorageServices";
// import moment from "moment";
// import AddEditLrModal from "modals/AddEditLrModal";
// import AddLrModal from "modals/AddLrModal";
// import { UserContext } from "context";
// import { IoChevronBack, IoChevronForward } from "react-icons/io5";
// import { utils } from "helper";
// import { getConsignorListData } from "_services/accountsServices/consignorServices";
// import { getBranchListApi } from "_services/dropdownServices/dropdownService";

// const SelectLrModal2 = (props) => {
//   const {
//     indexofTable,
//     listOfLr,
//     callbackSelectLr,
//     selectedLr,
//     isOpen,
//     branchList,
//     consignorList,
//     closeModal,
//     setSelectParty,
//     formLabelValue,
//     handlePermissionCallTrip = () => { },
//     branchFirmId
//   } = props;
//   const { masterData, setIsMaterialIndex } = useContext(UserContext)
//   const [selectedValue, setSelectedValue] = useState([]);
//   const [lrListFlag, setLrListFlag] = useState(false);
//   const [lrList, setLrList] = useState([]);
//   const [selectedRange, setSelectedRange] = useState({
//     startDate: '',
//     endDate: '',
//     // startDate: moment().subtract(32, "days"),
//     // endDate: moment(),
//   });

//   const [filter, setFilter] = useState({
//     date: moment(new Date()).format("YYYY-MM-DD"),
//     start_date: "",
//     end_date: "",
//     // branch_id: formLabelValue?.branch_id?._id || "",
//     branch_id: "",
//     firm_id: branchFirmId || "",
//     consignor_id: "",
//     keyword: "",
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const itemsPerPage = 25;


//   useEffect(() => {
//     const hasAnyLr = listOfLr?.length > 0;

//     if (hasAnyLr) {

//       setSelectedValue(
//         selectedLr?.map((item) => ({
//           consignor_id: item.consignor_id?._id,
//           lr_id: item._id,
//         }))
//       );
//     } else {
//       setSelectedValue([
//         {
//           consignor_id: "",
//           lr_id: "",
//         },
//       ]);
//     }
//   }, [isOpen]);


//   useEffect(() => {
//     if (selectedValue.length) {

//       getLrList(selectedValue[0]?.consignor_id ? selectedValue : []);
//     }
//   }, [selectedValue, filter, currentPage, selectedRange]);

//   useEffect(() => {
//     setCurrentPage(1)
//   }, [filter]);

//   const fetchConsignor = async (search, page, limit) => {
//     const res = await getConsignorListData({
//       company_id: StorageService.getCompanyId(),
//       firm_id: branchFirmId || StorageService.getFirmId(),
//       offset: page,
//       limit,
//       search,
//     });

//     if (res?.responseCode === 200) {

//       const list = await res?.data?.consignor_list?.map((i) => ({ ...i, label: i?.name, value: i?._id }))

//       return {
//         items: list,
//         total: res?.data?.total_record,
//       };
//     } else {

//       toast.error(res?.responseMessage);
//     }
//   };

//   const handleApply = (newRange) => {
//     setSelectedRange(newRange);
//     // setFilter({
//     //   start_date:moment(selectedRange.startDate).format("YYYY-MM-DD"),
//     //   end_date:moment(selectedRange.endDate).format("YYYY-MM-DD"),
//     // })
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };
//   const getLrList = async (selectId) => {

//     setLrListFlag(true);
//     const res = await getAllLrApi({
//       company_id: StorageService.getCompanyId(),
//       select_lr_ids: selectId,
//       lr_status: 1,
//       branch_id: filter?.branch_id?._id,
//       consignor_id: filter?.consignor_id?._id,
//       firm_id: filter?.firm_id,
//       search: filter?.keyword,
//       limit: itemsPerPage,
//       offset: currentPage,
//       start_date: selectedRange.startDate ? moment(selectedRange.startDate).format("YYYY-MM-DD") : "",
//       end_date: selectedRange.endDate ? moment(selectedRange.endDate).format("YYYY-MM-DD") : ""
//     });
//     if (res?.responseCode === 200) {

//       const billRaised = res?.data?.lr_list.filter((item) => item?.lr_status < 6);
//       setLrList(billRaised);
//       if (billRaised.length) {
//         setTotalItems(res?.data?.total_record);
//         setLrListFlag(false);
//       } else {
//         setLrListFlag(false);
//       }
//     } else {
//       toast.error(res?.responseMessage);
//     }
//   };

//   const handleSelect = (item, index) => {

//     const filterList = selectedLr?.some((lr) => lr?._id === item?._id); //[1]
//     if (!filterList) {
//       callbackSelectLr(item);
//       let newLrList = [...lrList];
//       newLrList.splice(index, 1);
//       setLrList(newLrList);
//       toast.success("LR Added");
//     } else {
//       toast.error("LR Already Exist");
//     }

//   };

//   const handleOnChange = async (name, value) => {
//     const stateObj = {
//       ...filter,
//       [name]: name == "consignor_id" ? value : value,
//     };
//     setFilter(stateObj);
//   };

//   const fetchBranch = async (search, page, limit) => {
//     const res = await getBranchListApi({
//       company_id: StorageService.getCompanyId(),
//      firm_id: branchFirmId || StorageService.getFirmId(),
//       offset: page,
//       limit,
//       search,
//     });

//     if (res?.responseCode === 200) {
//       // setLoading(false);
//       const list = await res?.data?.branch_list?.map((i) => ({
//         ...i,
//         label: i?.branch,
//         value: i?._id
//       }));

//       return {
//         items: list,
//         total: res?.data?.total_record,
//       };
//     } else {
//       // setLoading(false);
//     }
//   };


//   return (
//     <div>
//       <CommonModal {...props}>
//         <div className="_selectLrBody">
//           <div className="_sercFilts_bx">
//             <div className="plan_search_header">
//               <div className="_anvPlan_srOuter_bx">
//                 {/* <CommonInput
//                   type="date"
//                   label="Date"
//                   name="txn_date"
//                   value={filter?.date}
//                   onChange={({ target: { name, value } }) =>
//                     handleOnChange(name, value)
//                   }
//                 /> */}
//                 <CommonDateRange
//                   initialStartDate={
//                     selectedRange.startDate
//                       ? selectedRange.startDate
//                       : ""
//                   }
//                   initialEndDate={
//                     selectedRange.endDate
//                       ? selectedRange.endDate
//                       : ""
//                   }
//                   // onApply={(data) => dropdownFilterOnChange(data)}
//                   datePrefield={
//                     !selectedRange.endDate &&
//                       !selectedRange.startDate
//                       ? false
//                       : true
//                   }
//                   // initialStartDate={selectedRange.startDate}
//                   // initialEndDate={selectedRange.endDate}
//                   onApply={handleApply}
//                 />
//               </div>

//               <div className="_anvPlan_srOuter_bx">
//                 {/* <CustomSelect
//                   label="Branch Name"
//                   placeholder="Select Branch"
//                   options={branchList}
//                   name="branch_id"
//                   //   value={filter?.branch_id}
//                   value={
//                     filter?.branch_id
//                       ? branchList?.find((i) => i.value == filter?.branch_id)
//                       : { label: "", value: "" }
//                   }
//                   onSelect={(data) => {
//                     handleOnChange("branch_id", data.value);
//                   }}
//                 /> */}

//                 <CityDropdownForTrip
//                   label={"Branch"}
//                   placeholder="Select Branch"
//                   fetchData={fetchBranch}
//                   pageSize={20}
//                   onChange={(data) => {
//                     handleOnChange("branch_id", data);

//                   }}
//                   selectedItem={filter?.branch_id}
//                   // error={!!formError.branch_id}
//                   // errorMessage={formError.branch_id}
//                   isClearOption={filter?.branch_id?.value ? true : false}
//                   isClearHandleChange={() => {
//                     handleOnChange("branch_id", {}); // label: 'Assign Driver', value: ''
//                   }}
//                 />
//               </div>

//               <div className="_anvPlan_srOuter_bx">
//                 {/* <CustomSelect
//                   label="Consignor"
//                   placeholder="Select Consignor"
//                   options={consignorList}
//                   name="consignor_id"
//                   //   value={filter?.consignor_id}
//                   value={
//                     filter?.consignor_id
//                       ? consignorList?.find(
//                         (i) => i.value == filter?.consignor_id
//                       )
//                       : { label: "", value: "" }
//                   }
//                   onSelect={(data) => {
//                     handleOnChange("consignor_id", data.value);
//                   }}
//                 /> */}

//                 <CityDropdownForTrip
//                   label={"Consignor"}
//                   placeholder="Select Consignor"
//                   fetchData={fetchConsignor}
//                   pageSize={20}
//                   onChange={(data) => {
//                     handleOnChange("consignor_id", data);
//                   }}
//                   selectedItem={filter?.consignor_id}
//                   // error={!!formError.consignor_id}
//                   // errorMessage={formError.consignor_id}
//                   isClearOption={filter?.consignor_id?._id ? true : false}
//                   isClearHandleChange={() => {
//                     handleOnChange("consignor_id", {}); // label: 'Assign Driver', value: ''
//                   }}
//                 />
//               </div>

//               <div className="_anvPlan_srOuter_bx">
//                 <CommonInput
//                   type="text"
//                   label="Search field"
//                   name="keyword"
//                   value={filter?.keyword}
//                   onChange={({ target: { name, value } }) =>
//                     handleOnChange(name, value)
//                   }
//                 />
//               </div>
//             </div>

//             <div>
//               <button
//                 className="_addComm_btn"
//                 onClick={() => {
//                   handlePermissionCallTrip();

//                   closeModal();
//                 }}
//               >
//                 Add New LR
//               </button>
//             </div>
//           </div>
//           <div className="_selectLr_table">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Invoice Date</th>
//                   <th>Branch</th>
//                   <th>Consignor</th>
//                   <th>From Station</th>
//                   <th>To Station</th>
//                   <th>MLR/ LR Number</th>
//                   <th>Invoice/ PO Number</th>
//                   <th>Qty</th>
//                   <th>Weight</th>
//                   <th>KOT</th>
//                   <th>Status</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>

//               {lrList && lrList.length > 0 ? (
//                 <tbody>
//                   {lrList.map((i, index) => {

//                     return (
//                       <>
//                         <tr key={`lrList_${index}`}>
//                           <td>
//                             {moment(i?.invoice_date).format(" D  MMM YYYY")}
//                           </td>

//                           <td>{i?.branch_id?.branch}</td>

//                           <td>{i?.consignor_id?.name}</td>

//                           <td>
//                             <span className="_anv_lrLocation_span">
//                               {i?.from_location}
//                             </span>
//                             <br />
//                             <span className="_anvPlist_stBot">
//                               {i?.unit_id?.unit_code
//                                 ? i?.unit_id?.unit_code
//                                 : " -"}
//                               {i?.unit_id?.name ? i?.unit_id?.name : " -"}
//                             </span>
//                           </td>

//                           <td>
//                             <span className="_anv_lrLocation_span">
//                               {i?.to_location}
//                             </span>
//                             <br />
//                             <span className="_anvPlist_stBot">
//                               {i?.consignee_id?.name
//                                 ? i?.consignee_id?.name
//                                 : "--"}
//                             </span>
//                           </td>

//                           <td>{i?.mlr_number ? i?.mlr_number : "-"}</td>

//                           <td>
//                             {i?.invoice_number ? i?.invoice_number : "-"} <br />{" "}
//                             {i?.po_number ? i?.po_number : "-"}
//                           </td>

//                           <td>{i?.total_qty || utils.getTotalAmount(i?.lr_material_list, 'qty')}</td>

//                           <td>{i?.total_weight || utils.getTotalAmount(i?.lr_material_list, 'weight')}</td>

//                           <td>{i?.total_kot || utils.getTotalAmount(i?.lr_material_list, 'kot')}</td>

//                           <td>  <span className={masterData?.lr_status[i?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[i?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[i?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[i?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[i?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[i?.lr_status] ? masterData?.lr_status[i?.lr_status] : ''} </span></td>

//                           <td>
//                             <button
//                               onClick={() => handleSelect(i, index)}
//                               className="_addComm_btn"
//                             >
//                               Select
//                             </button>
//                           </td>
//                         </tr>
//                       </>
//                     );
//                   })}
//                 </tbody>
//               ) : lrListFlag ? (
//                 lrListFlag && (
//                   <tbody>
//                     <tr>
//                       <td>Loading...</td>
//                     </tr>
//                   </tbody>
//                 )
//               ) : (
//                 <tbody>
//                   <tr>
//                     <td>No Data</td>
//                   </tr>
//                 </tbody>
//               )}
//             </table>
//           </div>
//           {lrList.length > 0 && <div className="paginationFt_avt ">
//             <CustomPagination
//               totalItems={totalItems}
//               itemsPerPage={itemsPerPage}
//               currentPage={currentPage}
//               onPageChange={handlePageChange}
//             />
//           </div>}
//         </div>
//       </CommonModal>
//     </div>
//   );
// };

// export default SelectLrModal2;


import { getAllLrApi } from "_services";
import { CityDropdownForTrip, CommonDateRange, CommonInput, CommonModal, CustomPagination, CustomSelect } from "components";
import React, { useContext, useEffect, useState, useMemo } from "react";
import toast from "react-hot-toast";
import StorageService from "utils/StorageServices/StorageServices";
import moment from "moment";
import AddEditLrModal from "modals/AddEditLrModal";
import AddLrModal from "modals/AddLrModal";
import { UserContext } from "context";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { utils } from "helper";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import { getBranchListApi } from "_services/dropdownServices/dropdownService";

const SelectLrModal2 = (props) => {
  const {
    indexofTable,
    listOfLr,
    callbackSelectLr,
    selectedLr,
    isOpen,
    branchList,
    consignorList,
    closeModal,
    setSelectParty,
    formLabelValue,
    handlePermissionCallTrip = () => { },
    branchFirmId,

  } = props;
  const { masterData, setIsMaterialIndex, lrPermissions } = useContext(UserContext)
  const [selectedValue, setSelectedValue] = useState([]);
  const [lrListFlag, setLrListFlag] = useState(false);
  const [lrList, setLrList] = useState([]);
  const [selectedRange, setSelectedRange] = useState({
    startDate: '',
    endDate: '',
  });

  const [filter, setFilter] = useState({
    date: moment(new Date()).format("YYYY-MM-DD"),
    start_date: "",
    end_date: "",
    branch_id: formLabelValue?.branch_id,
    firm_id: branchFirmId || "",
    consignor_id: "",
    keyword: "",
  });
  const [selectingLrId, setSelectingLrId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 25;

  // Filter out already selected LRs from the displayed list
  const filteredLrList = useMemo(() => {
    if (!lrList.length) return [];

    const selectedLrIds = selectedLr?.map(lr => lr._id) || [];
    return lrList.filter(lr => !selectedLrIds.includes(lr._id));
  }, [lrList, selectedLr]);

  useEffect(() => {
    const hasAnyLr = listOfLr?.length > 0;

    if (hasAnyLr) {
      setSelectedValue(
        selectedLr?.map((item) => ({
          consignor_id: item.consignor_id?._id,
          lr_id: item._id,
        }))
      );
    } else {
      setSelectedValue([
        {
          consignor_id: "",
          lr_id: "",
        },
      ]);
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedValue.length) {
      getLrList(selectedValue[0]?.consignor_id ? selectedValue : []);
    }
  }, [selectedValue, filter, currentPage, selectedRange]);

  useEffect(() => {
    setCurrentPage(1)
  }, [filter]);

  const fetchConsignor = async (search, page, limit) => {
    const res = await getConsignorListData({
      company_id: StorageService.getCompanyId(),
      firm_id: branchFirmId || StorageService.getFirmId(),
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {
      const list = await res?.data?.consignor_list?.map((i) => ({ ...i, label: i?.name, value: i?._id }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getLrList = async (selectId) => {
    setLrListFlag(true);
    const res = await getAllLrApi({
      company_id: StorageService.getCompanyId(),
      select_lr_ids: selectId,
      lr_status: 1,
      branch_id: filter?.branch_id?._id,
      consignor_id: filter?.consignor_id?._id,
      firm_id: filter?.firm_id,
      search: filter?.keyword,
      limit: itemsPerPage,
      offset: currentPage,
      start_date: selectedRange.startDate ? moment(selectedRange.startDate).format("YYYY-MM-DD") : "",
      end_date: selectedRange.endDate ? moment(selectedRange.endDate).format("YYYY-MM-DD") : ""
    });
    if (res?.responseCode === 200) {
      const billRaised = res?.data?.lr_list.filter((item) => item?.lr_status < 6);
      setLrList(billRaised);
      if (billRaised.length) {
        setTotalItems(res?.data?.total_record);
        setLrListFlag(false);
      } else {
        setLrListFlag(false);
      }
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const handleSelect = async (item, index) => {
    setSelectingLrId(item._id); // Set loading state

    try {
      const filterList = selectedLr?.some((lr) => lr?._id === item?._id);

      if (!filterList) {
        await callbackSelectLr(item); // Make sure this is awaited if it's async
        toast.success("LR Added");
      } else {
        toast.error("LR Already Exist");
      }
    } catch (error) {
      toast.error("Failed to select LR");
    } finally {
      setSelectingLrId(null); // Clear loading state
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...filter,
      [name]: name == "consignor_id" ? value : value,
    };
    setFilter(stateObj);
  };

  const fetchBranch = async (search, page, limit) => {
    const res = await getBranchListApi({
      company_id: StorageService.getCompanyId(),
      firm_id: branchFirmId || StorageService.getFirmId(),
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {
      const list = await res?.data?.branch_list?.map((i) => ({
        ...i,
        label: i?.branch,
        value: i?._id
      }));

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      // Handle error
    }
  };

  return (
    <div>
      <CommonModal {...props}>
        <div className="_selectLrBody">
          <div className="_sercFilts_bx">
            <div className="plan_search_header" style={{ width: 'calc(100% - 130px)' }}>
              <div className="_anvPlan_srOuter_bx" style={{ flex: '1' }}>
                <CommonDateRange
                  initialStartDate={
                    selectedRange.startDate
                      ? selectedRange.startDate
                      : ""
                  }
                  initialEndDate={
                    selectedRange.endDate
                      ? selectedRange.endDate
                      : ""
                  }
                  datePrefield={
                    !selectedRange.endDate &&
                      !selectedRange.startDate
                      ? false
                      : true
                  }
                  onApply={handleApply}
                />
              </div>

              <div className="_anvPlan_srOuter_bx" style={{ flex: '1' }}>
                <CityDropdownForTrip
                  inputClass="__ctyDrop_trip"
                  label={"Branch"}
                  placeholder="Select Branch"
                  fetchData={fetchBranch}
                  pageSize={20}
                  onChange={(data) => {
                    handleOnChange("branch_id", data);
                  }}
                  selectedItem={filter?.branch_id}
                  isClearOption={filter?.branch_id?.value ? true : false}
                  isClearHandleChange={() => {
                    handleOnChange("branch_id", {});
                  }}
                />
              </div>

              <div className="_anvPlan_srOuter_bx" style={{ flex: '1' }}>
                <CityDropdownForTrip
                  inputClass="__ctyDrop_trip"
                  label={"Consignor"}
                  placeholder="Select Consignor"
                  fetchData={fetchConsignor}
                  pageSize={20}
                  onChange={(data) => {
                    handleOnChange("consignor_id", data);
                  }}
                  selectedItem={filter?.consignor_id}
                  isClearOption={filter?.consignor_id?._id ? true : false}
                  isClearHandleChange={() => {
                    handleOnChange("consignor_id", {});
                  }}
                />
              </div>

              <div className="_anvPlan_srOuter_bx" style={{ flex: '1' }}>
                <CommonInput
                  type="text"
                  label="Search field"
                  name="keyword"
                  value={filter?.keyword}
                  onChange={({ target: { name, value } }) =>
                    handleOnChange(name, value)
                  }
                />
              </div>
            </div>

            <div>
              {lrPermissions?.create === 1 && <button
                className="_addComm_btn"
                onClick={() => {
                  handlePermissionCallTrip();
                  closeModal();
                }}
              >
                Add New LR
              </button>}
            </div>
          </div>
          <div className="_selectLr_table">
            <table>
              <thead>
                <tr>
                  <th>Invoice Date</th>
                  <th>Branch</th>
                  <th>Consignor</th>
                  <th>From Station</th>
                  <th>To Station</th>
                  <th>MLR/ LR Number</th>
                  <th>Invoice/ PO Number</th>
                  <th>Qty</th>
                  <th>Weight</th>
                  <th>KOT</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              {filteredLrList && filteredLrList.length > 0 ? (
                <tbody>
                  {filteredLrList.map((i, index) => {
                    return (
                      <tr key={`lrList_${index}`}>
                        <td>
                          {moment(i?.invoice_date).format(" D  MMM YYYY")}
                        </td>

                        <td>{i?.branch_id?.branch}</td>

                        <td>{i?.consignor_id?.name}</td>

                        <td>
                          <span className="_anv_lrLocation_span">
                            {i?.from_location}
                          </span>
                          <br />
                          <span className="_anvPlist_stBot">
                            {[i?.unit_id?.unit_code, i?.unit_id?.name]
                              .filter(Boolean)
                              .join(" ") || "-"}
                          </span>
                          {/* <span className="_anvPlist_stBot">
                            {i?.unit_id?.unit_code
                              ? i?.unit_id?.unit_code
                              : " -"}
                            {i?.unit_id?.name ? i?.unit_id?.name : " -"}
                          </span> */}
                        </td>

                        <td>
                          <span className="_anv_lrLocation_span">
                            {i?.to_location}
                          </span>
                          <br />
                          <span className="_anvPlist_stBot">
                            {i?.consignee_id?.name
                              ? i?.consignee_id?.name
                              : "--"}
                          </span>
                        </td>

                        <td>{i?.mlr_number ? i?.mlr_number : "-"}</td>

                        <td>
                          {i?.invoice_number ? i?.invoice_number : "-"} <br />{" "}
                          {i?.po_number ? i?.po_number : "-"}
                        </td>

                        <td>{i?.total_qty || utils.getTotalAmount(i?.lr_material_list, 'qty')}</td>

                        <td>{i?.total_weight || utils.getTotalAmount(i?.lr_material_list, 'weight')}</td>

                        <td>{i?.total_kot || utils.getTotalAmount(i?.lr_material_list, 'kot')}</td>

                        <td>
                          <span className={masterData?.lr_status[i?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[i?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[i?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[i?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[i?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}>
                            {masterData?.lr_status[i?.lr_status] ? masterData?.lr_status[i?.lr_status] : ''}
                          </span>
                        </td>

                        <td>
                          <button
                            onClick={() => handleSelect(i, index)}
                            className="_addComm_btn"
                            disabled={selectingLrId === i._id}
                          >
                            {selectingLrId === i._id ? "Selecting..." : "Select"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : lrListFlag ? (
                lrListFlag && (
                  <tbody>
                    <tr>
                      <td>Loading...</td>
                    </tr>
                  </tbody>
                )
              ) : (
                <tbody>
                  <tr>
                    <td>No Data</td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
          {filteredLrList.length > 0 && <div className="paginationFt_avt ">
            <CustomPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>}
        </div>
      </CommonModal>
    </div>
  );
};

export default SelectLrModal2;